document.addEventListener('DOMContentLoaded', () => {
    const selectors = {
        loginTrigger: 'a#login-popup-trigger',
        loginPopup: 'div#login-popup',
        closePopup: '.close-popup',
        loginWrapper: 'div.login-wrapper',
        registerWrapper: 'div.register-wrapper',
        passwordRecover: 'div.password-recover',
        recoverPasswordLink: 'a[href="#recover"]',
        createAccountLink: '.create-account-link',
        backToLoginFromRegister: '.register-wrapper .back-to-login',
        recoverPasswordForm: 'form[action="/account/recover"]'
    };

    const elements = {};
    for (const key in selectors) {
        elements[key] = document.querySelector(selectors[key]);
    }

    function showElement(el) {
        if (el) el.classList.remove('hidden');
    }

    function hideElement(el) {
        if (el) el.classList.add('hidden');
    }

    function toggleElement(el) {
        if (el) el.classList.toggle('hidden');
    }

    function resetToLoginView() {
        showElement(elements.loginWrapper);
        hideElement(elements.registerWrapper);
        hideElement(elements.passwordRecover);
    }

    function openLoginPopup() {
        showElement(elements.loginPopup);
    }

    function closeLoginPopup() {
        hideElement(elements.loginPopup);
        setTimeout(resetToLoginView, 300);
    }

    // Event Listeners
    elements.loginTrigger?.addEventListener('click', (e) => {
        e.preventDefault();
        toggleElement(elements.loginPopup);
    });

    elements.closePopup?.addEventListener('click', (e) => {
        e.preventDefault();
        closeLoginPopup();
    });

    elements.recoverPasswordLink?.addEventListener('click', (e) => {
        e.preventDefault();
        hideElement(elements.loginWrapper);
        showElement(elements.passwordRecover);
    });

    const cancelRecoveryLink = elements.passwordRecover?.querySelector('a[href="#login"]');
    cancelRecoveryLink?.addEventListener('click', (e) => {
        e.preventDefault();
        hideElement(elements.passwordRecover);
        showElement(elements.loginWrapper);
    });

    elements.createAccountLink?.addEventListener('click', (e) => {
        e.preventDefault();
        hideElement(elements.loginWrapper);
        showElement(elements.registerWrapper);
    });

    const backToLoginBtn = document.querySelector(selectors.backToLoginFromRegister);
    backToLoginBtn?.addEventListener('click', (e) => {
        e.preventDefault();
        hideElement(elements.registerWrapper);
        showElement(elements.loginWrapper);
    });

    // Show recovery view on hash
    if (window.location.hash === '#recover') {
        openLoginPopup();
        hideElement(elements.loginWrapper);
        hideElement(elements.registerWrapper);
        showElement(elements.passwordRecover);
    }

    // Password toggle (shared handler)
    document.body.addEventListener('click', (e) => {
        const toggleBtn = e.target.closest('.toggle-password');
        if (!toggleBtn) return;

        const wrapper = toggleBtn.closest('.register-wrapper, .login-wrapper');
        if (!wrapper) return;

        const isRegister = wrapper.classList.contains('register-wrapper');
        const inputId = isRegister ? 'RegisterForm-password' : 'CustomerPassword';
        const iconId = isRegister ? 'eyeIcon' : 'loginEyeIcon';

        const input = document.getElementById(inputId);
        const icon = document.getElementById(iconId);

        if (!input || !icon) return;

        const isVisible = input.type === 'text';
        input.type = isVisible ? 'password' : 'text';

        icon.innerHTML = isVisible
            ? `<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
               <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />`
            : `<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" 
                d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.542-7a9.956 9.956 0 012.145-3.568m2.763-2.51A9.956 9.956 0 0112 5
                   c4.477 0 8.268 2.943 9.542 7a9.956 9.956 0 01-1.15 2.507M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
               <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M3 3l18 18" />`;
    });
});